module.exports = __webpack_public_path__ + "img/glamping_7.caa0c3cf.jpg";